module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_10y_y.0cdd9ddf.csv";